import React from 'react'
import { Route, Routes } from 'react-router'
import App from 'client/apps/login/components/app.js'
import Organizations from 'client/apps/login/components/organizations.js'
import IncorrectPassword from 'client/apps/login/components/incorrect-password.js'
import EmailSent from 'client/apps/password-reset/components/email-sent.js'
import EmailSendError from 'client/apps/password-reset/components/email-send-error.js'
import PasswordChangeSuccess from 'client/apps/change-password/components/change-success.js'
import PasswordChangeError from 'client/apps/change-password/components/change-error.js'
import { partition } from 'lodash'

import axios from 'axios'
import decode from 'jwt-decode'
import cookies from 'browser-cookies'
import { isTokenExpired } from './utils/jwt'
import AuthService from './utils/auth-service'

import Callback from 'client/apps/login/components/callback.js'
import PasswordReset from 'client/apps/password-reset/components/app.js'
import ChangePassword from 'client/apps/change-password/components/app.js'
import Http404 from './components/errors/404'
import Http403 from './components/errors/403'
import LoadError from './components/errors/load-error'
import { captureException } from './utils/raven'
import * as url from 'url'

import config from 'client/config'
import SSOOrgError from './components/errors/SSO-org-error'
import Component from 'client/components/component.js'
import updateLastLoginUtil from './utils/update-last-login'
import AccessDenied from './components/errors/access-denied'
import { normalizeUser } from '@lanetix/auth-utils'

export const parseAuthHash = async (location, params, navigate) => {
  const { org = 'default' } = params
  try {
    const { data: client } = await axios.get(`/api/v1/connections/${org}`)
    console.log('DATA:', client)
    const auth = new AuthService(client)
    const auth0Response = await auth.getOauthToken(client, location.search);
    console.log("AUTH0 RESPONSE:", auth0Response);
    let { accessToken, idToken } = auth0Response;
    // const { idToken } = await auth.parseHash(location.hash)
    console.log('idToken:', idToken)
    if (isTokenExpired(accessToken)) {
      throw new Error('token expired')
    }
    const user = normalizeUser(decode(accessToken))
    console.log('USER:', user)
    const {
      exp: expires,
      organization_id: orgId,
      instance_entrypoint: instanceEntrypoint
    } = user

    // Updating last_logged_in
    await updateLastLoginUtil.updateLastLoggedInTime(user, accessToken)

    const cookieOpts = Object.assign(
      {
        domain: config.cookiesApiTokenDomain,
        expires: new Date(expires * 1000),
        path: '/'
      },
      (config.isProduction ? { secure: true } : {})
    )

    cookies.set(
      'XSRF-TOKEN',
      accessToken,
      cookieOpts
    )

    const callbackURL = cookies.get('callbackURL')
    const mobile = cookies.get('mobile')
    const siteUrl = window.location.href
    const parsedUrl = url.parse(siteUrl, true)
    const pathName = parsedUrl.pathname.substring(1)
    let slugName = pathName.slice(0, pathName.indexOf('/'))
    slugName = slugName !== '' ? slugName : 'undefined'
    const response = await axios.get(`/api/v1/verify-SSO/${slugName}`, { headers: { token: accessToken } })
    console.log('RESPONSE:', response)
    if (response.data && response.data.orgWithoutSSOlogin && response.data.orgWithoutSSOlogin.length === 0) {
      const [mobileSlug, slug] = partition(response.data.orgWithSSOlogin[0].slugs, s => s.includes('mobile'))
      const ssoUrl = mobile ? mobileSlug[0] : slug[0]
      const orgNames = response.data.orgWithSSOlogin[0].organization_name
      cookies.erase('XSRF-TOKEN')
      window.location.replace('/sso-org-error?org=' + encodeURIComponent(orgNames) + '&ssolink=' + encodeURIComponent(ssoUrl))
    } else {
      if (callbackURL && !mobile) {
        window.location.replace(callbackURL)
      } else if (mobile) {
        window.location.replace(config.mobileSsoCallbackUri + accessToken)
      } else {
        // If the org is DHL Supply Chain, redirect to DSC land page
        const redirectUri = (parseInt(orgId, 10) === parseInt(config.dscOrgId, 10))
          ? config.dscUri
          : instanceEntrypoint || config.uiUri
        window.location.replace(redirectUri)
      }
    }
  } catch (e) {
    console.log('error in parseAuthHash')
    console.log(e)
    captureException(e)
    if (org === 'default') {
      navigate('/error', { replace: true })
    } else {
      if (e.errorDescription && e.errorDescription.includes('orgError')) {
        navigate(`/${org}/access-denied`, { replace: true })
      } else navigate(`/${org}/error`, { replace: true })
    }
  }
}

export default () => {
  return (
    <Routes>
      <Route element={<Component />}>
        <Route path='/' errorElement={<LoadError />}>
          <Route index element={<App />} />
          <Route path='orgs' element={<Organizations />} />
          <Route path='callback' element={<Callback />} />
          <Route path='error' element={<Http403 />} />
          <Route path='incorrect-password' element={<IncorrectPassword />} />
          <Route path='sso-org-error' element={<SSOOrgError />} />
        </Route>
        <Route path='/forgot-password' errorElement={<LoadError />}>
          <Route index element={<PasswordReset />} />
          <Route path='email-sent' element={<EmailSent />} />
          <Route path='email-send-error' element={<EmailSendError />} />
          <Route path='reset/success' element={<PasswordChangeSuccess />} />
          <Route path='reset/error' element={<PasswordChangeError />} />
          <Route path='reset/:resetToken' element={<ChangePassword />} />
        </Route>
        <Route path='/:org' errorElement={<LoadError />} >
          <Route index element={<App />} />
          <Route path='orgs' element={<Organizations />} />
          <Route path='callback' element={<Callback />} />
          <Route path='error' element={<Http403 />} />
          <Route path='access-denied' element={<AccessDenied />} />
        </Route>
      </Route>
      <Route path='*' element={<Http404 />} />
    </Routes>
  )
}
